import { Input } from '@/components/ui/input'
import { FormFieldProps, FormStringType } from './type'
import { useFormContext } from 'react-hook-form'

export const FormStringField = ({
  data,
  field,
}: FormFieldProps<FormStringType>) => {
  const { resolver } = data

  const { getValues } = useFormContext()

  return (
    <Input
      {...field}
      value={resolver ? resolver(getValues()) : field.value}
      className="disabled:!border-0 disabled:opacity-75"
      disabled={data.readOnly}
      placeholder={data.placeholder?.toString() || data.label}
      defaultValue={
        typeof data.default === 'function' ? data.default() : data.default
      }
      autoComplete="new-password"
      type={data.secure ? 'password' : 'text'}
    />
  )
}
